import { RouterModule, Routes } from '@angular/router';
import { AppMainComponent } from './layout/main.component';

// Pages
import { PageLoginComponent } from './extra-pages/login/login.component';
import { PageDownloadSCAL360Component } from './extra-pages/DownloadSCAL360/DownloadSCAL360.component';

// Page Layouts
import { AdalAccessGuard } from './shared/adal-access.guard';
import { LicensePortalComponent } from './license-portal/license-portal.component';
import { HomePageComponent } from './extra-pages/HomePage/home-page.component';
import { PageLayoutUserComponent } from './user-management/user/user.component';
import { UserManagementComponent } from './user-management/user-management.component';
import { AdvertisementComponent } from './advertisement/advertisement.component';
import { AddNewAdvertisementDialogComponent } from './advertisement/add-new-advertisement/add-new-advertisement.component';
import { AccessDeniedComponent } from './layout/access-denied/access-denied.component';

const AppRoutes: Routes = [ 
    // { path: 'dashboard', redirectTo: 'home-page', pathMatch: 'full',canActivate: [AdalAccessGuard]},
    { path: 'buildinstrument', redirectTo: '/app/buildinstrument', pathMatch: 'full' },
    { path: 'access-denied', component: AccessDeniedComponent },
    { path: 'app', component: AppMainComponent,canActivateChild:[AdalAccessGuard] },
    { path: 'login', component: PageLoginComponent },    
    { path: 'home-page',component:HomePageComponent},   
    { path: 'DownloadSCAL360', component: PageDownloadSCAL360Component },                            
    { path: 'license-portal', component: LicensePortalComponent },   
    { path: 'user-management',component:UserManagementComponent},
    { path: 'advertisement', component:AdvertisementComponent},
    { path: '**', redirectTo: 'home-page', pathMatch: 'full'},
];
export const AppRoutingModule = RouterModule.forRoot(AppRoutes, { useHash: true });



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/app-routing.module.ts